.fd{background-color:inherit;}